import axios, { configPromise } from './axiosInit';
import fallbackConfig from '../../config';

const getThemeConfig = async () =>
{
    try
    {
        const auth = {
            headers: {
                Authorization: 'Bearer ' + 'IL9rRlzf9y5KgdwkGMbPNpaBykyCaPx1XMu3IQTq'
            }
        }

        const result = await axios.get('https://cms.node2cloud.com/api/887609e4740f4f4e99af57cb467c53cd/themeconfig', auth);
        return result
    } catch (e)
    {
        // console.log(e)
    }
}

const getConfig = async () =>
{
    try
    {
        if (configPromise)
        {
            const config = await configPromise;
            if (config) return config;
        }
        const res = await axios.get('config.json');
        return res.data || fallbackConfig;
    } catch (e)
    {
        console.error('Error loading config.json:', e);
        return fallbackConfig;
    }
}

const getAgreementLinks = async () =>
{
    try
    {
        const config = await getConfig();
        if (config && config.AGREEMENT_LINKS)
        {
            return config.AGREEMENT_LINKS;
        }
        if (config && (config.eng || config.arb))
        {
            return { eng: config.eng, arb: config.arb };
        }
    } catch (e)
    {
        console.error('Error fetching agreement links:', e);
    }
    return fallbackConfig.AGREEMENT_LINKS;
}

export default {
    getThemeConfig,
    getConfig,
    getAgreementLinks
}
